import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { cn, getInitials } from '@/lib/utils'

interface MemberAvatarProps {
  name: string
  className?: string
}

export function MemberAvatar({ name, className }: MemberAvatarProps) {
  return (
    <Avatar className={cn('h-8 w-8', className)}>
      <AvatarFallback className="bg-primary text-xs font-bold text-primary-foreground">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  )
}
